import { forwardRef, createElement } from 'react';

function IconSales(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M12.021 23.316c.594 0 1.121-.33 1.121-1.12V21.14c3.546-.382 5.761-2.465 5.761-5.498 0-2.61-1.569-4.192-4.825-4.904l-2.676-.606C9.727 9.763 8.91 8.999 8.91 7.878c0-1.344 1.16-2.32 2.98-2.32 1.476 0 2.504.5 3.651 1.78.58.606 1.029.83 1.635.83.738 0 1.305-.514 1.305-1.279 0-.738-.435-1.542-1.173-2.267-.976-.923-2.439-1.53-4.087-1.74V1.787c0-.777-.527-1.107-1.134-1.107-.593 0-1.12.316-1.12 1.107v1.055c-3.415.317-5.59 2.36-5.59 5.287 0 2.557 1.569 4.258 4.575 4.93l2.676.62c1.951.461 2.755 1.147 2.755 2.307 0 1.503-1.173 2.452-3.27 2.452-1.568 0-2.873-.593-4.06-1.872-.672-.672-1.041-.817-1.542-.817-.805 0-1.411.514-1.411 1.397 0 .778.448 1.582 1.252 2.281 1.055.962 2.703 1.556 4.536 1.727v1.042c0 .79.527 1.12 1.133 1.12z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Sales = /*#__PURE__*/forwardRef(IconSales);

export default Sales;
//# sourceMappingURL=Sales.js.map
